;(function () {
  'use strict'

  angular.module('contrast.rules').factory('RulesService', RulesService)

  function RulesService(RuleFactory, ServiceUtils, AGENT_LANGUAGE) {
    'ngInject'

    var allLanguages = 'All application languages'

    // API
    var service = {
      get: get,
      getByApplication: getByApplication,
      getApplicationsPolicyByRule: getApplicationsPolicyByRule,
      updateStatus: updateStatus,
      updateStatusByRule: updateStatusByRule,
      updateStatusByApplication: updateStatusByApplication,
      bulkUpdateStatusByApplication: bulkUpdateStatusByApplication,
      getQuickFilters: getQuickFilters,
      getDrilldownQuickFilters: getDrilldownQuickFilters,
      restoreDefaults: restoreDefaults
    }

    return service

    // Function Definitions
    function get(params) {
      return RuleFactory.getRules(params)
        .then(function (response) {
          _.each(response.data.rules, function (rule) {
            _.extend(rule, { severity: rule.severity.toUpperCase() })
          })

          _.each(response.data.rules, function (rule) {
            if (rule.languages.length === AGENT_LANGUAGE.length) {
              _.extend(rule, { languages: [allLanguages] })
            }
          })

          return response.data
        })
        .catch(ServiceUtils.handleError)
    }

    function getByApplication(appId, params) {
      return RuleFactory.getRulesByApplication(appId, params)
        .then(function (response) {
          _.each(response.data.rules, function (rule) {
            _.extend(rule, { severity: rule.severity.toUpperCase() })
          })
          return response.data
        })
        .catch(ServiceUtils.handleError)
    }

    function getApplicationsPolicyByRule(ruleId, params) {
      return RuleFactory.getApplicationsPolicyByRule(ruleId, params)
        .then(function (response) {
          return response.data
        })
        .catch(ServiceUtils.handleError)
    }

    function updateStatus(rule, enabled, environment) {
      return RuleFactory.updateStatus(rule.name, enabled, environment)
        .then(
          ServiceUtils.handleResolve('data', {
            log: ServiceUtils.LOGGER.SUCCESS
          })
        )
        .catch(ServiceUtils.handleError)
    }

    function updateStatusByRule(
      appIds,
      ruleId,
      filterText,
      quickFilter,
      devEnv,
      qaEnv,
      prodEnv
    ) {
      return RuleFactory.updateStatusByRule(
        appIds,
        ruleId,
        filterText,
        quickFilter,
        devEnv,
        qaEnv,
        prodEnv
      ).catch(ServiceUtils.handleError)
    }

    function updateStatusByApplication(appId, rule, enabled, environment) {
      return RuleFactory.updateStatusByApplication(
        appId,
        rule.rule_name,
        enabled,
        environment
      ).catch(ServiceUtils.handleError)
    }

    function bulkUpdateStatusByApplication(
      appId,
      ruleNames,
      devEnabled,
      qaEnabled,
      prodEnabled
    ) {
      return RuleFactory.bulkUpdateStatusByApplication(
        appId,
        ruleNames,
        devEnabled,
        qaEnabled,
        prodEnabled
      )
        .then(
          ServiceUtils.handleResolve('data', {
            log: ServiceUtils.LOGGER.SUCCESS
          })
        )
        .catch(ServiceUtils.handleError)
    }

    function getQuickFilters(searchKeywords) {
      var data = {
        q: searchKeywords
      }

      return RuleFactory.getRulesQuickFilters(data)
        .then(function (response) {
          return response.data.filters
        })
        .catch(ServiceUtils.handleError)
    }

    function getDrilldownQuickFilters(ruleId, searchKeywords) {
      var data = {
        q: searchKeywords
      }

      return RuleFactory.getRuleDrilldownQuickFilters(ruleId, data)
        .then(function (response) {
          return response.data.filters
        })
        .catch(ServiceUtils.handleError)
    }

    function restoreDefaults(rule) {
      return RuleFactory.restoreDefaults(rule.name)
        .then(
          ServiceUtils.handleResolve('data', {
            log: ServiceUtils.LOGGER.SUCCESS
          })
        )
        .catch(ServiceUtils.handleError)
    }
  }
})()
